var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection"},[_c('alllistNews',{attrs:{"datalink":_vm.phplink+'app/index.php?id=zhiyuanfengcai&ot=1'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }